module.exports = __webpack_public_path__ + "img/skill-1.46819363.svg";